import { Action } from '@ngrx/store';
import { InitialUnreadCountModel } from '../shared/data/models/initial-unread-count.model';

export enum ApplictionsTypes {
  LoadUser = '[App] Load User',
  RefreshLiveUser = '[App] Refresh Live User',
  LoadUserSuccess = '[App] Load User Success',
  LoadUserError = '[App] Load User Error',

  Authenticate = '[App] Authenticated user',

  ClearSessionLogin = '[App] Clear Current User',

  SetNotifications = '[App] Set Notifications',
  LoadNotificationSuccess = '[App] Load Notification Success',
  IncrementMessageNotification = '[App] IncrementMessageNotification',
  IncrementNormalNotification = '[App] IncrementNormalNotification',

  DecrementMessageNotification = '[App] DecrementMessageNotification',
  DecrementNormalNotification = '[App] DecrementNormalNotification',

  ShowPassword = '[App] Show Password',
  HidePassword = '[App] Hide Password',

  UserSubscription = '[App] User Subscription, ME'
}

// action creators
export class LoadUser implements Action {
  readonly type = ApplictionsTypes.LoadUser;
}

export class RefreshLiveUser {
  readonly type = ApplictionsTypes.RefreshLiveUser;
}

export class LoadUserSuccess implements Action {
  readonly type = ApplictionsTypes.LoadUserSuccess;

  // user model
  constructor(public payload: any) {}
}

export class LoadUserError implements Action {
  readonly type = ApplictionsTypes.LoadUserError;

  constructor(public payload: string) {}
}

export class Authenticate implements Action {
  readonly type = ApplictionsTypes.Authenticate;

  constructor(public payload: boolean) {}
}

export class ClearSessionLogin implements Action {
  readonly type = ApplictionsTypes.ClearSessionLogin;
}

export class LoadNotifications implements Action {
  readonly type = ApplictionsTypes.SetNotifications;
}

export class LoadNotificationSuccess implements Action {
  readonly type = ApplictionsTypes.LoadNotificationSuccess;

  constructor(public payload: InitialUnreadCountModel) {}
}

export class IncrementMessageNotification implements Action {
  readonly type = ApplictionsTypes.IncrementMessageNotification;
}

export class IncrementNormalNotification implements Action {
  readonly type = ApplictionsTypes.IncrementNormalNotification;
}

export class DecrementMessageNotification implements Action {
  readonly type = ApplictionsTypes.DecrementMessageNotification;
}

export class DecrementNormalNotification implements Action {
  readonly type = ApplictionsTypes.DecrementNormalNotification;
}

export class ShowPassword implements Action {
  readonly type = ApplictionsTypes.ShowPassword;
}

export class HidePassword implements Action {
  readonly type = ApplictionsTypes.HidePassword;
}

export class UserSubscription implements Action {
  readonly type = ApplictionsTypes.UserSubscription;
}

export type AppActions =
  | LoadUser
  | LoadUserSuccess
  | LoadUserError
  | RefreshLiveUser
  | Authenticate
  | ClearSessionLogin
  | LoadNotifications
  | LoadNotificationSuccess
  | IncrementMessageNotification
  | IncrementNormalNotification
  | DecrementMessageNotification
  | DecrementNormalNotification
  | ShowPassword
  | HidePassword
  | UserSubscription;
